module.exports = new __parcel__URL__("crocodile.221fa99c.svg").toString();